import { Routes, Route } from 'react-router-dom';

import {
  DefaultCampaign,
  SourceCampaignList,
  ClientCampaignList,
  ClientSpocCampaignList,
  JobCampaignList,
  CampaignSettings,
} from '../features';

import CardWrapper from './CardWrapper';

export const AutomatedEmailCampaignChildRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <CardWrapper>
          <DefaultCampaign />
        </CardWrapper>
      }
    />
    <Route
      path="/client-spoc"
      element={
        <CardWrapper>
          <ClientSpocCampaignList />
        </CardWrapper>
      }
    />
    <Route
      path="/client"
      element={
        <CardWrapper>
          <ClientCampaignList />
        </CardWrapper>
      }
    />
    <Route
      path="/job"
      element={
        <CardWrapper>
          <JobCampaignList />
        </CardWrapper>
      }
    />
    <Route
      path="/source"
      element={
        <CardWrapper>
          <SourceCampaignList />
        </CardWrapper>
      }
    />
    <Route path="/campaign-settings" element={<CampaignSettings />} />
  </Routes>
);
